import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddProductFeedbackMutationVariables = Types.Exact<{
  input: Types.Product_Feedback_Insert_Input;
}>;


export type AddProductFeedbackMutation = { __typename?: 'mutation_root', insert_product_feedback_one?: { __typename?: 'product_feedback', id: any, installed_product_id?: any | null, product_id: any, rating: any, notes?: string | null, created_at: any, product_feedback_attachments: Array<{ __typename?: 'product_feedback_attachments', id: any, photo_link?: string | null, video_link?: string | null, type: string }> } | null };


export const AddProductFeedbackDocument = gql`
    mutation addProductFeedback($input: product_feedback_insert_input!) {
  insert_product_feedback_one(object: $input) {
    id
    installed_product_id
    product_id
    rating
    notes
    product_feedback_attachments {
      id
      photo_link
      video_link
      type
    }
    created_at
  }
}
    `;
export type AddProductFeedbackMutationFn = Apollo.MutationFunction<AddProductFeedbackMutation, AddProductFeedbackMutationVariables>;

/**
 * __useAddProductFeedbackMutation__
 *
 * To run a mutation, you first call `useAddProductFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductFeedbackMutation, { data, loading, error }] = useAddProductFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<AddProductFeedbackMutation, AddProductFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductFeedbackMutation, AddProductFeedbackMutationVariables>(AddProductFeedbackDocument, options);
      }
export type AddProductFeedbackMutationHookResult = ReturnType<typeof useAddProductFeedbackMutation>;
export type AddProductFeedbackMutationResult = Apollo.MutationResult<AddProductFeedbackMutation>;
export type AddProductFeedbackMutationOptions = Apollo.BaseMutationOptions<AddProductFeedbackMutation, AddProductFeedbackMutationVariables>;